import { render, staticRenderFns } from "./AnnouncementPreview.vue?vue&type=template&id=510d668d"
import script from "./AnnouncementPreview.vue?vue&type=script&lang=js"
export * from "./AnnouncementPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports